import React, { useEffect, useRef, useState } from "react";
import "../../../CSS/Candidate.css";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  Tooltip,
  Skeleton,
  Modal as ChakraModal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  GridItem,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  useToast
} from "@chakra-ui/react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faFileExport } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import {
  CloseIcon,
  ExternalLinkIcon,
  HamburgerIcon,
  PhoneIcon,
} from "@chakra-ui/icons";
import { CSVLink } from "react-csv";
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import {
  fetchCandidateListAsync,
  selectCandidates,
  selectCandidatesTotal,
  updateJobStatusAsync,
} from "../CandidateSlice/Basic/CandidateSlice";
import { TimeDifference } from "../../../../common/TimeDifference";
import Modal from "../../Modal";
import { fetchEmployerCandidateJobApplyExportbyStatusAsync } from "../../../employerDataExports/employerCandidateJobApplyListByStatusExport/employerCandidateJobApplyListByStatusExportSlice";
const Shortlisted = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const toast = useToast();
  const dispatch = useDispatch();
  const candidates = useSelector(selectCandidates);
  const records = candidates?.records?.data;
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedUuid, setSelectedUuid] = useState(null);
  const total = candidates?.status_counts?.shortlist;
  // const [isExporting, setIsExporting] = useState(false);
  const CandidatesPerPage = 15;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(total / CandidatesPerPage);
  const [csvData, setCsvData] = useState([]);
  const [isExporting, setIsExporting] = useState(false);
  const csvLinkRef = useRef();
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handleApplicantClick = (candidate) => {
    if (candidate.is_candidate_unlock) {
      const url = `/employer-dashboard/show-candidate/${candidate.candidate.uuid}`;
      window.open(url, "_blank");

      toast({
        title: "Opening candidate profile",
        description: `Viewing ${candidate.candidate?.name}'s detailed profile`,
        status: "info",
        duration: 2000,
        isClosable: true,
        position: "top-right",
      });
    } else {
      toast({
        title: "Unlock required",
        description: "You need to unlock this candidate before viewing their profile.",
        status: "warning",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const handleShortlist = (uuid) => {
    setSelectedUuid(uuid);
    setSelectedAction("shortlist");
  };

  const handleReject = (uuid) => {
    setSelectedUuid(uuid);
    setSelectedAction("rejected");
  };

  const handleOnHold = (uuid) => {
    setSelectedUuid(uuid);
    setSelectedAction("on_hold");
  };

  const handleContacting = (uuid) => {
    setSelectedUuid(uuid);
    setSelectedAction("contacted");
  };

  const handleCloseDialog = () => {
    setSelectedAction(null);
    setSelectedUuid(null);
  };

  

  const excelHeaders = [
    { header: "Name", key: "candidate_name", width: 20 },
    { header: "Email", key: "candidate_email", width: 25 },
    { header: "Phone", key: "candidate_phone", width: 15 },
    { header: "Gender", key: "candidate_gender", width: 10 },
    { header: "Date of Birth", key: "candidate_dob", width: 15 },
    { header: "Experience (Years)", key: "candidate_experience_year", width: 18 },
    { header: "Experience (Months)", key: "candidate_experience_month", width: 18 },
    { header: "Work Status", key: "candidate_work_status", width: 15 },
    { header: "Current City", key: "candidate_current_city", width: 15 },
    { header: "Job Title", key: "candidate_title", width: 20 },
    { header: "Preferred Cities", key: "preferred_cities", width: 25 },
  ];

  const location = useLocation();

  const handleExportToExcel = async () => {
    setIsExporting(true);
    try {
      const result = await dispatch(fetchEmployerCandidateJobApplyExportbyStatusAsync({
        status: "shortlist"
      })).unwrap();

      if (Array.isArray(result)) {
        const formattedData = result.map(candidate => ({
          // candidate_uuid: candidate.candidate_uuid || 'N/A',
          candidate_name: candidate.candidate_name || 'N/A',
          candidate_email: candidate.candidate_email || 'N/A',
          candidate_phone: candidate.candidate_phone || 'Not provided',
          candidate_gender: candidate.candidate_gender || 'N/A',
          candidate_dob: candidate.candidate_dob || 'N/A',
          candidate_experience_year: candidate.candidate_experience_year || 0,
          candidate_experience_month: candidate.candidate_experience_month || 0,
          candidate_work_status: candidate.candidate_work_status || 'N/A',
          candidate_current_city: candidate.candidate_current_city || 'N/A',
          candidate_title: candidate.candidate_title || 'N/A',
          preferred_cities: candidate.candidate_preferred_city
            ? candidate.candidate_preferred_city.map(city => city.location.title).join(', ')
            : 'N/A',
          // unlocked_at: candidate.unlocked_at || 'N/A'
        }));

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Shortlisted Candidates');

        // Set up columns with headers
        worksheet.columns = excelHeaders;

        // Style the header row
        const headerRow = worksheet.getRow(1);
        headerRow.font = { bold: true };
        headerRow.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFFF00' } // Yellow background
        };
        headerRow.alignment = { horizontal: 'center' };
        headerRow.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };

        // Add data rows
        formattedData.forEach(candidate => {
          worksheet.addRow(candidate);
        });

        // Auto-fit columns and add borders to all cells
        worksheet.eachRow((row, rowNumber) => {
          row.eachCell((cell, colNumber) => {
            cell.border = {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' }
            };

            // Center align data rows
            if (rowNumber > 1) {
              cell.alignment = { horizontal: 'center' };
            }
          });
        });

        // Generate Excel file and save
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const fileName = `shortlisted-candidates-details-${new Date().toISOString().split('T')[0]}.xlsx`;
        saveAs(blob, fileName);

        toast({
          title: "Export Successful",
          description: "Candidate data has been exported to Excel successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        throw new Error("Unexpected response format. Expected an array.");
      }
    } catch (error) {
      toast({
        title: "Export Failed",
        description: error.message || "Failed to export candidate data.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsExporting(false);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      fetchCandidateListAsync({
        page: currentPage,
        status: "shortlist",
      }),
    )
      .unwrap()
      .then(() => setIsLoading(false))
      .catch((error) => {
        console.error("Error fetching shortlisted candidates:", error);
        setIsLoading(false);
      });
  }, [dispatch, currentPage, location.pathname]);

  const handleOpenModal = (candidate) => {
    setSelectedCandidate(candidate);
    setIsModalVisible(true);
    dispatch(fetchCandidateListAsync({ page: currentPage, status: "" })).unwrap();
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setSelectedCandidate(null);
    dispatch(fetchCandidateListAsync({ page: currentPage, status: "" })).unwrap();
  };



  const getRoleBadgeColor = (skills) => {
    if (!skills || skills.length === 0) return { bg: "#e5e7eb", color: "#374151", text: "General" };

    const skillTitles = skills.map((s) => s?.skill?.title?.toLowerCase()).join(" ");

    if (skillTitles.includes("react") || skillTitles.includes("frontend") || skillTitles.includes("javascript")) {
      return { bg: "#dbeafe", color: "#1e40af", text: "Frontend" };
    }
    if (skillTitles.includes("node") || skillTitles.includes("backend") || skillTitles.includes("python")) {
      return { bg: "#dcfce7", color: "#166534", text: "Backend" };
    }
    if (skillTitles.includes("design") || skillTitles.includes("ui") || skillTitles.includes("ux")) {
      return { bg: "#fef3c7", color: "#92400e", text: "UI Design" };
    }
    if (skillTitles.includes("marketing") || skillTitles.includes("digital")) {
      return { bg: "#fce7f3", color: "#be185d", text: "Marketing" };
    }
    if (skillTitles.includes("data") || skillTitles.includes("analytics")) {
      return { bg: "#e0e7ff", color: "#3730a3", text: "Data" };
    }

    return { bg: "#f3f4f6", color: "#374151", text: "General" };
  };

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case "shortlist":
        return "status-green";
      case "rejected":
        return "status-red";
      case "on_hold":
        return "status-yellow";
      default:
        return "status-blue";
    }
  };

  const DetailedCandidateCard = ({ candidate }) => {
    const roleBadge = getRoleBadgeColor(candidate.candidate?.it_skills);

    return (
      <div className="detailed-card">
        {/* Header Section */}
        <div className="card-header-section">
          <div className="avatar-info">
            <div className="basic-info">
              <h3 className="candidate-name-detailed hover:underline mb-2" onClick={() => handleApplicantClick(candidate)}>
                {candidate.candidate?.name}
              </h3>

              <div className="status-badges">
                <span className={`unlock-badge ${candidate.is_candidate_unlock ? "unlocked" : "locked"}`}>
                  {candidate.is_candidate_unlock ? "Unlocked" : "Locked"}
                </span>
                <span className="match-badge">{candidate?.profile_matching_percantage}% Match</span>
              </div>
            </div>
          </div>
          <div className="quick-stats">
            <div className={`stat-item ${getStatusBadgeClass(candidate?.status)}`}>
              <span className="font-medium"> {candidate?.status === "interview_scheduled" ? "Interview Scheduled" : candidate?.status?.toUpperCase()}</span>
            </div>
          </div>
        </div>

        {/* Details Section */}
        <div className="card-details">
          <div className="detail-row">
            <div className="detail-item">
              <i className="fa-solid fa-user detail-icon"></i>
              <span className="detail-text">{candidate.candidate?.basic_details?.gender || "Not provided"}</span>
            </div>
            <div className="detail-item">
              <i className="fa-solid fa-briefcase detail-icon"></i>
              <span className="detail-text">
                {candidate.candidate?.basic_details?.experience_year === 0 &&
                  candidate.candidate?.basic_details?.experience_month === 0
                  ? "Fresher"
                  : `${candidate.candidate?.basic_details?.experience_year}y ${candidate.candidate?.basic_details?.experience_month}m`}
              </span>
            </div>
          </div>

          <div className="detail-row">
            <div className="detail-item">
              <i className="fa-solid fa-location-dot detail-icon"></i>
              <span className="detail-text">
                {candidate.candidate?.basic_details?.city?.name}, {candidate.candidate?.basic_details?.state?.name}
              </span>
            </div>
            <div className="detail-item">
              <i className="fa-solid fa-calendar detail-icon"></i>
              <span className="detail-text">{candidate.candidate?.basic_details?.dob || "Not provided"}</span>
            </div>
          </div>

          <div className="skills-section">
            <div className="skills-label">
              <i className="fa-solid fa-code detail-icon"></i>
              <span>Skills:</span>
            </div>
            <div className="skills-list">
              {candidate.candidate?.it_skills?.length > 0
                ? candidate.candidate.it_skills
                  .slice(0, 3)
                  .map((skillObj) => skillObj?.skill?.title)
                  .join(", ") +
                (candidate.candidate.it_skills.length > 3 ? ` +${candidate.candidate.it_skills.length - 3} more` : "")
                : "No skills listed"}
            </div>
          </div>

          <div className="job-section">
            <div className="job-info">
              <i className="fa-solid fa-building detail-icon"></i>
              <Link to={`/employer-dashboard/manage-jobs/${candidate?.job?.uuid}`} className="job-link hover:underline">
                {candidate?.job?.job_title?.title || "No Job Title"}
              </Link>
            </div>
            <div className="status-info">
              <span className={`status-badge ${getStatusBadgeClass(candidate?.status)}`}>
                {candidate?.status === "interview_scheduled" ? "Interview Scheduled" : candidate?.status?.toUpperCase()}
              </span>
            </div>
          </div>

          <div className="job-section">
            <div className="job-info">
              <i className="fa-solid fa-building detail-icon"></i>
              <div className="job-link">
                {candidate?.candidate?.current_company_details?.current_company || "No Current Company"}
              </div>

            </div>

          </div>
          <div className="job-section">
            <div className="job-info">
              <i className="fa-solid fa-building detail-icon"></i>
              <div className="job-link">
                {candidate?.candidate?.current_company_details?.notice_period || "No Notice Period"}
              </div>

            </div>

          </div>

          <div className="time-info">
            <i className="fa-solid fa-clock detail-icon"></i>
            <TimeDifference dateTimeString={candidate.created_at} />
          </div>
        </div>

        {/* Actions Section */}
        <div className="card-actions">
          <button
            className="action-btn-detailed btn-red"
            onClick={(e) => {
              e.stopPropagation();
              handleReject(candidate.uuid);
            }}
            title="Reject"
          >
            <i className="fa-solid fa-xmark"></i>
          </button>

          <Menu>
            <MenuButton
              as={IconButton}
              aria-label="Options"
              icon={<HamburgerIcon />}
              variant="outline"
              colorScheme="yellow"
              onClick={(e) => e.stopPropagation()}
              size={"sm"}
            />
            <MenuList>
              <MenuItem
                icon={<PhoneIcon />}
                onClick={(e) => {
                  e.stopPropagation();
                  let phone = candidate.candidate?.phone;

                  if (!phone) {
                    alert("Phone number not available");
                    return;
                  }

                  phone = String(phone);
                  const sanitizedPhone = phone.replace(/[^\d+]/g, "");

                  const isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);

                  if (isMobile) {
                    window.location.href = `tel:${sanitizedPhone}`;
                  } else {
                    const searchUrl = `https://www.google.com/search?q=${encodeURIComponent(sanitizedPhone)}`;
                    window.open(searchUrl, "_blank");
                  }
                }}
              >
                Call
              </MenuItem>
              <MenuItem
                icon={<ExternalLinkIcon />}
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenModal(candidate);
                }}
              >
                Setup Interview
              </MenuItem>
              <MenuItem
                icon={<CloseIcon />}
                onClick={(e) => {
                  e.stopPropagation();
                  handleOnHold(candidate.uuid);
                }}
              >
                Put On Hold
              </MenuItem>
              <MenuItem
                icon={<PhoneIcon />}
                onClick={(e) => {
                  e.stopPropagation();
                  handleContacting(candidate.uuid);
                }}
              >
                Contact
              </MenuItem>
            </MenuList>
          </Menu>
        </div>
      </div>
    );
  };

  const LoadingCard = () => (
    <div className="detailed-card loading">
      <div className="card-header-section">
        <div className="avatar-info">
          <div className="avatar-container">
            <div className="card-avatar skeleton"></div>
            <div className="role-badge-card skeleton"></div>
          </div>
          <div className="basic-info">
            <div className="skeleton skeleton-name"></div>
            <div className="skeleton skeleton-email"></div>
            <div className="skeleton skeleton-badges"></div>
          </div>
        </div>
      </div>
      <div className="card-details">
        <div className="skeleton skeleton-line"></div>
        <div className="skeleton skeleton-line"></div>
        <div className="skeleton skeleton-line"></div>
      </div>
    </div>
  );

  const CandidateActionDialog = ({
    isOpen,
    onClose,
    onConfirm,
    candidateUuid,
    actionType,
  }) => {
    const dispatch = useDispatch();
    const cancelRef = React.useRef();

    const actionLabels = {
      shortlist: {
        title: "Shortlist Candidate",
        body: "Are you sure you want to shortlist this candidate?",
        confirmColor: "green",
      },
      rejected: {
        title: "Reject Candidate",
        body: "Are you sure you want to reject this candidate?",
        confirmColor: "red",
      },
      on_hold: {
        title: "Put Candidate On Hold",
        body: "Are you sure you want to put this candidate on hold?",
        confirmColor: "yellow",
      },
      contacted: {
        title: "Contact Candidate",
        body: "Are you sure you want to contact this candidate?",
        confirmColor: "blue",
      },
    };

    const handleConfirm = async () => {
      try {
        await dispatch(
          updateJobStatusAsync({
            uuid: candidateUuid,
            newStatus: actionType,
          })
        );
        await dispatch(
          fetchCandidateListAsync({ page: currentPage, status: "shortlist" })
        );
        onClose();
      } catch (error) {
        console.error(
          `Error updating candidate status to ${actionType}:`,
          error
        );
      }
    };

    return (
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {actionLabels[actionType]?.title}
            </AlertDialogHeader>

            <AlertDialogBody>{actionLabels[actionType]?.body}</AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button
                colorScheme={actionLabels[actionType]?.confirmColor}
                onClick={handleConfirm}
                ml={3}
              >
                Confirm
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    );
  };

  return (
    <div>
      <div className="py-4">
        <div className="flex justify-end mb-4">
          {/* <CSVLink
            data={csvData}
            headers={csvHeaders}
            filename="Shortlisted-candidates-details.csv"
            className="hidden"
            ref={csvLinkRef}
            target="_blank"
          /> */}
          <Button
            colorScheme="green"
            leftIcon={<FontAwesomeIcon icon={faFileExport} />}
            onClick={handleExportToExcel}
            isLoading={isExporting}
            loadingText="Exporting..."
          >
            Export to Excel
          </Button>
        </div>
        {isLoading ? (
          <div className="detailed-grid">
            {[...Array(9)].map((_, index) => (
              <LoadingCard key={index} />
            ))}
          </div>
        ) : records && records.filter((candidate) => candidate.status === "shortlist").length > 0 ? (
          <div className="detailed-grid">
            {records
              .filter((candidate) => candidate.status === "shortlist")
              .map((candidate) => (
                <DetailedCandidateCard key={candidate.id} candidate={candidate} />
              ))}
          </div>
        ) : (
          <div className="no-candidates">
            <div className="no-candidates-text">No candidates found</div>
          </div>
        )}

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="pagination-container">
            <div className="pagination">
              <button
                className={`pagination-btn ${currentPage === 1 ? "disabled" : ""}`}
                onClick={handlePrevPage}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <span className="pagination-info">
                Page {currentPage} of {totalPages}
              </span>
              <button
                className={`pagination-btn pagination-btn-primary ${currentPage === totalPages ? "disabled" : ""}`}
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>

      <CandidateActionDialog
        isOpen={!!selectedAction}
        onClose={handleCloseDialog}
        candidateUuid={selectedUuid}
        actionType={selectedAction}
      />

      {isModalVisible && selectedCandidate && (
        <Modal candidate={selectedCandidate} onClose={handleCloseModal} />
      )}

      <style jsx>{`
        .detailed-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
          gap: 16px;
        }

        .detailed-card {
          background: white;
          border-radius: 16px;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
          border: 1px solid #e5e7eb;
          transition: all 0.3s ease;
          cursor: pointer;
          overflow: hidden;
        }

        .detailed-card:hover {
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
          transform: translateY(-2px);
        }

        .card-header-section {
          padding: 20px 20px 16px 20px;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          border-bottom: 1px solid #f3f4f6;
        }

        .avatar-info {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          flex: 1;
        }

        .avatar-container {
          position: relative;
          flex-shrink: 0;
        }

        .card-avatar {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          object-fit: cover;
          border: 1px;
        }

        .role-badge-card {
          position: absolute;
          top: -4px;
          right: -8px;
          padding: 3px 8px;
          border-radius: 10px;
          font-size: 10px;
          font-weight: 600;
          white-space: nowrap;
        }

        .basic-info {
          flex: 1;
          min-width: 0;
        }

        .candidate-name-detailed {
          font-size: 18px;
          font-weight: 700;
          color: #1f2937;
          margin: 0 0 4px 0;
          text-transform: capitalize;
        }

        .candidate-email-detailed {
          font-size: 13px;
          color: #6b7280;
          margin: 0 0 8px 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .status-badges {
          display: flex;
          gap: 6px;
          flex-wrap: wrap;
        }

        .unlock-badge {
          padding: 2px 8px;
          border-radius: 10px;
          font-size: 10px;
          font-weight: 500;
        }

        .unlock-badge.unlocked {
          background-color: #dcfce7;
          color: #166534;
        }

        .unlock-badge.locked {
          background-color: #fee2e2;
          color: #991b1b;
        }

        .match-badge {
          padding: 2px 8px;
          border-radius: 10px;
          font-size: 10px;
          font-weight: 500;
          background-color: #dbeafe;
          color: #1e40af;
        }

        .quick-stats {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding:8px;
        }

        .stat-item {
          text-align: center;
          padding: 6px 10px;
          background: #f8fafc;
          border-radius: 8px;
          border: 1px solid #e2e8f0;
        }

        .stat-value {
          display: block;
          font-size: 16px;
          font-weight: 700;
          color: #059669;
        }

        .stat-label {
          font-size: 10px;
          color: #6b7280;
          font-weight: 500;
        }

        .card-details {
          padding: 16px 20px;
        }

        .detail-row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 12px;
          gap: 16px;
        }

        .detail-item {
          display: flex;
          align-items: center;
          gap: 8px;
          flex: 1;
          min-width: 0;
        }

        .detail-icon {
          color: #6b7280;
          font-size: 12px;
          width: 14px;
          flex-shrink: 0;
        }

        .detail-text {
          font-size: 13px;
          color: #4b5563;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .skills-section {
          margin-bottom: 12px;
        }

        .skills-label {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 13px;
          font-weight: 600;
          color: #374151;
          margin-bottom: 4px;
        }

        .skills-list {
          font-size: 12px;
          color: #6b7280;
          line-height: 1.4;
          padding-left: 22px;
        }

        .job-section {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 12px;
          gap: 12px;
        }

        .job-info {
          display: flex;
          align-items: center;
          gap: 8px;
          flex: 1;
          min-width: 0;
        }

        .job-link {
          font-size: 13px;
          color: #3b82f6;
          text-decoration: none;
          font-weight: 500;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .job-link:hover {
          color: #2563eb;
        }

        .status-info {
          flex-shrink: 0;
        }

        .status-badge {
          padding: 4px 8px;
          border-radius: 8px;
          font-size: 10px;
          font-weight: 600;
          text-transform: uppercase;
        }

        .status-green {
          background-color: #dcfce7;
          color: #166534;
        }

        .status-red {
          background-color: #fee2e2;
          color: #991b1b;
        }

        .status-yellow {
          background-color: #fef3c7;
          color: #92400e;
        }

        .status-blue {
          background-color: #dbeafe;
          color: #1e40af;
        }

        .time-info {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 11px;
          color: #9ca3af;
        }

        .card-actions {
          display: flex;
          justify-content: space-evenly;
          padding: 12px 20px 16px 20px;
          border-top: 1px solid #f3f4f6;
        }

        .action-btn-detailed {
          width: 36px;
          height: 36px;
          border-radius: 8px;
          border: 1px solid;
          background: white;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          transition: all 0.2s ease;
        }

        .btn-green {
          border-color: #10b981;
          color: #10b981;
        }

        .btn-green:hover {
          background-color: #ecfdf5;
        }

        .btn-red {
          border-color: #ef4444;
          color: #ef4444;
        }

        .btn-red:hover {
          background-color: #fef2f2;
        }

        .btn-yellow {
          border-color: #f59e0b;
          color: #f59e0b;
        }

        .btn-yellow:hover {
          background-color: #fffbeb;
        }

        .btn-gray {
          border-color: #9ca3af;
          color: #9ca3af;
        }

        .btn-gray:hover {
          background-color: #f9fafb;
        }

        /* Loading States */
        .loading {
          pointer-events: none;
        }

        .skeleton {
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
          border-radius: 4px;
        }

        .skeleton-name {
          height: 18px;
          width: 140px;
          margin-bottom: 4px;
        }

        .skeleton-email {
          height: 13px;
          width: 180px;
          margin-bottom: 8px;
        }

        .skeleton-badges {
          height: 16px;
          width: 120px;
        }

        .skeleton-line {
          height: 13px;
          margin-bottom: 8px;
        }

        .skeleton-line:nth-child(1) { width: 100%; }
        .skeleton-line:nth-child(2) { width: 85%; }
        .skeleton-line:nth-child(3) { width: 70%; }

        @keyframes loading {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }

        /* Other existing styles */
        .no-candidates {
          background: white;
          border-radius: 12px;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
          padding: 32px;
          text-align: center;
          border: 1px solid #e5e7eb;
        }

        .no-candidates-text {
          color: #6b7280;
          font-size: 18px;
        }

        .pagination-container {
          display: flex;
          justify-content: center;
          margin-top: 32px;
        }

        .pagination {
          display: flex;
          align-items: center;
          gap: 16px;
          background-color: #f3f4f6;
          padding: 16px;
          border-radius: 8px;
        }

        .pagination-btn {
          background-color: #6b7280;
          color: white;
          padding: 8px 16px;
          border-radius: 6px;
          border: none;
          cursor: pointer;
          font-size: 14px;
        }

        .pagination-btn-primary {
          background-color: #3b82f6;
        }

        .pagination-btn.disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .pagination-info {
          font-weight: 600;
          font-size: 14px;
        }

        @media (max-width: 768px) {
          .detailed-grid {
            grid-template-columns: 1fr;
            gap: 12px;
          }
          
          .card-header-section {
            flex-direction: column;
            gap: 12px;
          }
          
          .detail-row {
            flex-direction: column;
            gap: 8px;
          }
          
          .job-section {
            flex-direction: column;
            align-items: flex-start;
            gap: 8px;
          }
        }
      `}</style>
    </div>
  );
};

export default Shortlisted;